import { RenderableSprite3D } from "./RenderableSprite3D";
import { MeshFilter } from "./MeshFilter";
import { MeshRenderer } from "./MeshRenderer";
export class MeshSprite3D extends RenderableSprite3D {
    get meshFilter() {
        return this._meshFilter;
    }
    get meshRenderer() {
        return this._render;
    }
    constructor(mesh = null, name = null) {
        super(name);
        this._meshFilter = this.addComponent(MeshFilter);
        this._render = this.addComponent(MeshRenderer);
        (mesh) && (this._meshFilter.sharedMesh = mesh);
    }
}
